// extracted by mini-css-extract-plugin
module.exports = {"popupViewContainer":"popupView_popupViewContainer__eU1jw","h100":"popupView_h100__1MCjU","scroll":"popupView_scroll__1MCv6","styledScrollbars":"popupView_styledScrollbars__3olko"};